/**
 * Builds the sidebar `to` path for the resource explorer, including `filters`
 * query keys consumed by the catalog entity list (same pattern as the catalog index URL).
 *
 * @param ownerRefs - Optional owner entity refs (for example group or user) to pre-select in the owner filter
 * @returns Relative path for the sidebar link target
 */
export function buildResourceExplorerTo(
  ownerRefs: readonly string[],
): string {
  const params = new URLSearchParams();
  params.set('filters[kind]', 'resource');
  for (const ref of ownerRefs) {
    const trimmed = ref.trim();
    if (trimmed) {
      params.append('filters[owners]', trimmed);
    }
  }
  return `resource-explorer?${params.toString()}`;
}
